var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.campaign
    ? _c("div", { staticClass: "col-md-10 mx-10" }, [
        _c("label", { staticClass: "label" }, [_vm._v("LUM Groups")]),
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c(
              "Selectize",
              {
                attrs: {
                  multiple: "",
                  disabled: _vm.disabled,
                  settings: _vm.groupSelectizeSetting,
                },
                model: {
                  value: _vm.selected,
                  callback: function ($$v) {
                    _vm.selected = $$v
                  },
                  expression: "selected",
                },
              },
              _vm._l(_vm.lumUserGroup, function (group) {
                return _c(
                  "option",
                  { key: group.id, domProps: { value: group.id } },
                  [
                    _vm._v(
                      " " +
                        _vm._s(" " + group.id + " - " + group.group_name) +
                        " "
                    ),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }